import $ from 'jquery';

$(function () {
    if ($('#spontaneous-application').length) {
        const form = document.querySelector('#spontaneous-application .wpcf7-form');

        const requiredInputs = Array.from(form.querySelectorAll('input[aria-required="true"]'));
        const checkboxInput = form.querySelector('#accept-politique');

        const submitButton = form.querySelector('.wpcf7-submit');
        submitButton.disabled = true;

        const updateSubmitButton = () => {
            const allInputsFilled = requiredInputs.every((input) => input.value.trim() !== '');
            submitButton.disabled = !allInputsFilled || !checkboxInput.checked;
        };
        requiredInputs.forEach((input) => {
            input.addEventListener('input', updateSubmitButton);
        });
        checkboxInput.addEventListener('change', updateSubmitButton);
    }
});
